/**
 * websiteInfo模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const websiteInfo = {
  //检验网站是否可以TCP连接
  verifyWebsiteInfoConnected(params) {
    return $http.post(`${global.API_URL}/sme/websiteInfo/verifyWebsiteInfoConnected`, params);
  }
}

export default websiteInfo;



// WEBPACK FOOTER //
// ./src/api/websiteInfo.js